import React from 'react'
import styled from 'styled-components'
import { animated, useSpring } from 'react-spring'
import { radius, space, springConfig } from 'config/theme'
import { pxToRem } from 'utils/helpers'
import { COLORS, TEL_NUMBER } from 'config/constants'
import { Box } from 'components/atoms/Layout'
import { ReactComponent as PhoneCallIcon } from 'assets/svg/phone-call.svg'
import { math, lighten } from 'polished'
import Link from 'components/atoms/Link'

const BADGE_DIAMETER = pxToRem(80)

const boxShadow = `
  rgba(0, 0, 0, 0.06) 0 ${pxToRem(1)} ${pxToRem(6)} 0,
  rgba(0, 0, 0, 0.16) 0 ${pxToRem(2)} ${pxToRem(32)} 0
`

const Badge = styled.button`
  display: flex;
  width: ${BADGE_DIAMETER};
  height: ${BADGE_DIAMETER};
  background-color: ${COLORS.CATALAN};
  border-radius: ${math(`${BADGE_DIAMETER} / 2`)};
  box-shadow: ${boxShadow};
  outline: none;
`

const StyledPhoneCallIcon = styled(PhoneCallIcon)`
  flex: none;
  margin: auto;
`

const Content = styled.div`
  background-color: ${COLORS.CATALAN};
  padding: ${space.m} ${space.l};
  text-align: right;
  box-shadow: ${boxShadow};
  border-radius: ${radius.m} 0 0 ${radius.m};
`

const FloatingBadge = () => {
  const [isBadgeOpen, setIsBadgeOpen] = React.useState(false)
  const slideLeftConditional = useSpring({
    from: { transform: `translateX(100%)` },
    transform: isBadgeOpen ? `translateX(0)` : `translateX(100%)`,
    ...springConfig,
  })
  const slideLeft = useSpring({
    from: { transform: `translateX(100%)` },
    transform: `translateX(0)`,
    delay: 2000,
    ...springConfig,
  })

  return (
    <React.Fragment>
      <Box
        as={animated.div}
        position="fixed"
        bottom={math(`${BADGE_DIAMETER} + ${space.m}`)}
        right="0"
        flex="none"
        mb="m"
        style={slideLeftConditional}
      >
        <Content>
          <Link
            display="block"
            color={lighten(0.45, COLORS.CATALAN)}
            hoverColor="white"
            fontWeight="semi_bold"
            href={`tel:${TEL_NUMBER}`}
          >
            tel: {TEL_NUMBER}
          </Link>
          <Link
            display="block"
            color={lighten(0.45, COLORS.CATALAN)}
            hoverColor="white"
            fontWeight="semi_bold"
            href="mailto: hi@hinunu.com"
          >
            email: hi@hinunu.com
          </Link>
        </Content>
      </Box>
      <Box
        as={animated.div}
        style={slideLeft}
        position="fixed"
        right="0"
        bottom="0"
        p="m"
      >
        <Badge onClick={() => setIsBadgeOpen(!isBadgeOpen)}>
          <StyledPhoneCallIcon
            stroke={lighten(0.45, COLORS.ARAGON_GREEN)}
            strokeWidth="1.5"
          />
        </Badge>
      </Box>
    </React.Fragment>
  )
}

export default FloatingBadge
